module.exports = __webpack_public_path__ + "img/icon_back.b2094a45.d1094ea5.svg";